import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import MainLayout from '../components/layout/MainLayout';

// Páginas de autenticação
import Login from '../pages/Auth/Login';

// Páginas principais (protegidas)
import Dashboard from '../pages/Dashboard';
import CRM from '../pages/CRM';
import Campaigns from '../pages/Campaigns';
import DisparosList from '../pages/Campaigns/DisparosList';
import DisparosCreate from '../pages/Campaigns/DisparosCreate';
import DisparosEdit from '../pages/Campaigns/DisparosEdit';
import Sms from '../pages/Campaigns/Sms';
import SmsList from '../pages/Campaigns/SmsList';
import VoiceCreate from '../pages/Campaigns/VoiceCreate';
import Followups from '../pages/Followups';
import Inbox from '../pages/Inbox';
import WhatsApp from '../pages/Inbox/WhatsApp';
import WhatsAppRecovery from '../pages/Inbox/WhatsAppRecovery';
import DynamicWhatsAppInbox from '../pages/Inbox/DynamicWhatsAppInbox';
import Telegram from '../pages/Inbox/Telegram';
import TelegramDashboard from '../pages/TelegramDashboard';
import Instagram from '../pages/Inbox/Instagram';
import Executions from '../pages/Executions';
import Settings from '../pages/Settings';
import CallLogs from '../pages/CallLogs';
import CallTemplateManager from '../components/CallTemplateManager';
import Agenda from '../pages/Agenda';
import WhatsAppAuto from '../pages/WhatsAppAuto';
import WhatsAppQR from '../pages/WhatsAppQR';
import WhatsAppManual from '../pages/WhatsAppManual';
import WhatsAppDashboard from '../pages/WhatsAppDashboard';
import WhatsAppProxyConfig from '../pages/WhatsAppProxyConfig';
import MessageQueue from '../pages/WhatsAppAuto/MessageQueue';
import WhatsAppCloudApi from '../pages/WhatsAppCloudApi';
import ClientManagement from '../pages/ClientManagement';
import QuizFunnelTracker from '../pages/QuizFunnelTracker';
import FacebookOAuthCallback from '../pages/FacebookOAuthCallback';
import EmbeddedSignupLauncher from '../pages/EmbeddedSignupLauncher';
import FacebookAdsDashboard from '../pages/FacebookAds/Dashboard';
import FacebookAdsCampaigns from '../pages/FacebookAds/Campaigns';
import FacebookAdsAdSets from '../pages/FacebookAds/AdSets';
import FacebookAdsAds from '../pages/FacebookAds/Ads';
import FacebookAdsBulkOperations from '../pages/FacebookAds/BulkOperations';
import FacebookAdsLeads from '../pages/FacebookAds/Leads';
import FacebookAdsConnections from '../pages/FacebookAds/Connections';
import FinancialControlDashboard from '../pages/FinancialControl/Dashboard';
import FinancialControlProjects from '../pages/FinancialControl/Projects';
import FinancialControlRevenue from '../pages/FinancialControl/Revenue';
import FinancialControlExpenses from '../pages/FinancialControl/Expenses';
import Kanban from '../pages/Kanban';
import BoardView from '../pages/Kanban/BoardView';
import Integrations from '../pages/Integrations';
import IntegrationMetrics from '../pages/IntegrationMetrics';
import ControlDashboard from '../pages/Control/ControlDashboard';
import SupportDashboard from '../pages/Support/SupportDashboard';
import AbandonedCartDashboard from '../pages/AbandonedCart/AbandonedCartDashboard';
import EmailCampaigns from '../pages/EmailCampaigns';
import EmailTemplates from '../pages/EmailTemplates';
import EmailAutomations from '../pages/EmailAutomations';
import SmsAutomations from '../pages/SmsAutomations';
import SmsTemplates from '../pages/SmsTemplates';
import Attendants from '../pages/Attendants';
import AttendantsDashboard from '../pages/AttendantsDashboard';

// Páginas da Clínica
import Patients from '../pages/Clinic/Patients';
import Appointments from '../pages/Clinic/Appointments';
import MedicalRecords from '../pages/Clinic/MedicalRecords';
import Evolutions from '../pages/Clinic/Evolutions';
import Procedures from '../pages/Clinic/Procedures';
import PatientSources from '../pages/Clinic/PatientSources';
import Professionals from '../pages/Clinic/Professionals';
import Inventory from '../pages/Clinic/Inventory';
import Budgets from '../pages/Clinic/Budgets';
import ClinicSettings from '../pages/Clinic/ClinicSettings';
import Prescriptions from '../pages/Clinic/Prescriptions';
import ExamOrders from '../pages/Clinic/ExamOrders';
import Laboratory from '../pages/Clinic/Laboratory';
import Certificates from '../pages/Clinic/Certificates';
import Referrals from '../pages/Clinic/Referrals';
import Receipts from '../pages/Clinic/Receipts';
import NFSe from '../pages/Clinic/NFSe';
import InsuranceManagement from '../pages/Clinic/InsuranceManagement';
import WaitingRoom from '../pages/Clinic/WaitingRoom';
import ImageGallery from '../pages/Clinic/ImageGallery';
import TreatmentPlan from '../pages/Clinic/TreatmentPlan';
import Reports from '../pages/Clinic/Reports';
import AnamnesisTemplates from '../pages/Clinic/AnamnesisTemplates';
import ReminderSettings from '../pages/Clinic/ReminderSettings';
import DigitalSignature from '../pages/Clinic/DigitalSignature';
import Doctoralia from '../pages/Clinic/Doctoralia';
import UserManagement from '../pages/UserManagement';
import PlatformPlanPayments from '../pages/PlatformPlanPayments';
import AdminUnits from '../pages/Admin/Units';

// Teleconsulta
import PatientTeleconsultPage from '../pages/Teleconsulta/PatientTeleconsultPage';
import ProfessionalTeleconsultPage from '../pages/Teleconsulta/ProfessionalTeleconsultPage';

// Páginas do Financeiro
import FinancialDashboard from '../pages/Financial/FinancialDashboard';
import AccountsPayable from '../pages/Financial/AccountsPayable';
import AccountsReceivable from '../pages/Financial/AccountsReceivable';
import CashRegister from '../pages/Financial/CashRegister';
import FinancialAudit from '../pages/Financial/FinancialAudit';
import BankStatements from '../pages/Financial/BankStatements';
import Repasses from '../pages/Financial/Repasses';
import TefTransactions from '../pages/Financial/TefTransactions';
import NfseCompanies from '../pages/Financial/NfseCompanies';
import ChecksReceived from '../pages/Financial/ChecksReceived';
import ChecksIssued from '../pages/Financial/ChecksIssued';
import CardSettlements from '../pages/Financial/CardSettlements';
import PendingDiscounts from '../pages/Financial/PendingDiscounts';
import ProfessionalFees from '../pages/Financial/ProfessionalFees';
import Dre from '../pages/Financial/Dre';
import ChartOfAccounts from '../pages/Financial/ChartOfAccounts';
import DreSnapshots from '../pages/Financial/DreSnapshots';

// Páginas do Estoque
import InventoryMain from '../pages/Inventory/InventoryMain';
import InventoryCategories from '../pages/Inventory/InventoryCategories';
import InventoryLocations from '../pages/Inventory/InventoryLocations';
import InventoryManufacturers from '../pages/Inventory/InventoryManufacturers';
import InventoryKits from '../pages/Inventory/InventoryKits';
import InsuranceMedications from '../pages/Inventory/InsuranceMedications';
import InventoryMovements from '../pages/Inventory/InventoryMovements';
import InventoryRequisitions from '../pages/Inventory/InventoryRequisitions';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Rota pública - Login */}
      <Route path="/login" element={<Login />} />
      <Route path="/facebook/callback" element={<FacebookOAuthCallback />} />
      <Route path="/embedded-signup-launcher" element={<EmbeddedSignupLauncher />} />
      {/* Teleconsulta pública (paciente) — sem autenticação */}
      <Route path="/teleconsulta/p/:token" element={<PatientTeleconsultPage />} />

      {/* Layout principal com menu lateral para todas as páginas protegidas */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        {/* Rota raiz - redirecionar para agenda */}
        <Route index element={<Navigate to="/agenda" replace />} />
        
        {/* Rotas protegidas com menu lateral */}
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="crm" element={<CRM />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="campaigns/disparos" element={<DisparosList />} />
        <Route path="campaigns/disparos/create" element={<DisparosCreate />} />
        <Route path="campaigns/disparos/edit/:id" element={<DisparosEdit />} />
        <Route path="campaigns/sms" element={<SmsList />} />
        <Route path="campaigns/sms/create" element={<Sms />} />
        <Route path="campaigns/voice" element={<VoiceCreate />} />
        <Route path="campaigns/email-campaigns" element={<EmailCampaigns />} />
        <Route path="campaigns/email-templates" element={<EmailTemplates />} />
        <Route path="automations/email" element={<EmailAutomations />} />
        <Route path="automations/sms" element={<SmsAutomations />} />
        <Route path="automations/sms-templates" element={<SmsTemplates />} />
        <Route path="followups" element={<Followups />} />
        <Route path="inbox" element={<Inbox />} />
        <Route path="inbox/whatsapp" element={<WhatsApp />} />
        <Route path="inbox/whatsapp-recovery" element={<WhatsAppRecovery />} />
        <Route path="inbox/telegram" element={<Telegram />} />
        <Route path="telegram-dashboard" element={<TelegramDashboard />} />
        <Route path="inbox/instagram" element={<Instagram />} />
        {/* Rota dinâmica para inboxes adicionais configurados via variáveis de ambiente */}
        <Route path="inbox/:inboxSlug" element={<DynamicWhatsAppInbox />} />
        <Route path="executions" element={<Executions />} />
        <Route path="call-logs" element={<CallLogs />} />
        <Route path="call-templates" element={<CallTemplateManager />} />
        <Route path="agenda" element={<Agenda />} />
        <Route path="agenda-expandida" element={<Agenda expandedLayout />} />
        <Route path="whatsapp-auto" element={<WhatsAppAuto />} />
        <Route path="whatsapp-auto/queue" element={<MessageQueue />} />
        <Route path="whatsapp-manual" element={<WhatsAppManual />} />
        <Route path="whatsapp-qr" element={<WhatsAppQR />} />
        <Route path="whatsapp-dashboard" element={<WhatsAppDashboard />} />
        <Route path="whatsapp-proxy" element={<WhatsAppProxyConfig />} />
        <Route path="whatsapp-cloud-api" element={<WhatsAppCloudApi />} />
        <Route path="client-management" element={<ClientManagement />} />
        <Route path="quiz-funnel" element={<QuizFunnelTracker />} />
        <Route path="facebook-ads" element={<FacebookAdsDashboard />} />
        <Route path="facebook-ads/campaigns" element={<FacebookAdsCampaigns />} />
        <Route path="facebook-ads/adsets" element={<FacebookAdsAdSets />} />
        <Route path="facebook-ads/ads" element={<FacebookAdsAds />} />
        <Route path="facebook-ads/bulk" element={<FacebookAdsBulkOperations />} />
        <Route path="facebook-ads/leads" element={<FacebookAdsLeads />} />
        <Route path="facebook-ads/connections" element={<FacebookAdsConnections />} />
        <Route path="financial-control" element={<FinancialControlDashboard />} />
        <Route path="financial-control/projects" element={<FinancialControlProjects />} />
        <Route path="financial-control/revenue" element={<FinancialControlRevenue />} />
        <Route path="financial-control/expenses" element={<FinancialControlExpenses />} />
        <Route path="kanban" element={<Kanban />} />
        <Route path="kanban/:boardId" element={<BoardView />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="integrations/:provider/metrics" element={<IntegrationMetrics />} />
        <Route path="control" element={<ControlDashboard />} />
        <Route path="support" element={<SupportDashboard />} />
        <Route path="abandoned-cart" element={<AbandonedCartDashboard />} />
        <Route path="attendants" element={<Attendants />} />
        <Route path="attendants/dashboard" element={<AttendantsDashboard />} />
        
        {/* Rotas da Clínica — /clinic apenas redireciona (dashboard dedicado foi removido) */}
        <Route path="clinic" element={<Navigate to="/agenda" replace />} />
        <Route path="clinic/patients" element={<Patients />} />
        <Route path="clinic/appointments" element={<Appointments />} />
        <Route path="clinic/medical-records" element={<MedicalRecords />} />
        <Route path="clinic/evolutions" element={<Evolutions />} />
        <Route path="clinic/procedures" element={<Procedures />} />
        <Route path="clinic/patient-sources" element={<PatientSources />} />
        <Route path="clinic/professionals" element={<Professionals />} />
        <Route path="clinic/inventory" element={<Inventory />} />
        <Route path="clinic/budgets" element={<Budgets />} />
        <Route path="clinic/prescriptions" element={<Prescriptions />} />
        <Route path="clinic/exam-orders" element={<ExamOrders />} />
        <Route path="clinic/settings" element={<ClinicSettings />} />
        <Route path="clinic/laboratory" element={<Laboratory />} />
        <Route path="clinic/certificates" element={<Certificates />} />
        <Route path="clinic/referrals" element={<Referrals />} />
        <Route path="clinic/insurance" element={<InsuranceManagement />} />
        <Route path="clinic/waiting-room" element={<WaitingRoom />} />
        <Route path="clinic/image-gallery" element={<ImageGallery />} />
        <Route path="clinic/treatment-plan" element={<TreatmentPlan />} />
        <Route path="clinic/reports" element={<Reports />} />
        <Route path="clinic/anamnesis-templates" element={<AnamnesisTemplates />} />
        <Route path="clinic/reminder-settings" element={<ReminderSettings />} />
        <Route path="clinic/digital-signature" element={<DigitalSignature />} />
        <Route path="clinic/doctoralia" element={<Doctoralia />} />
        <Route path="clinic/teleconsulta/:appointmentId" element={<ProfessionalTeleconsultPage />} />
        
        {/* Rotas do Financeiro */}
        <Route path="financial/dashboard" element={<FinancialDashboard />} />
        <Route path="financial/accounts-payable" element={<AccountsPayable />} />
        <Route path="financial/accounts-receivable" element={<AccountsReceivable />} />
        <Route path="financial/cash-register" element={<CashRegister />} />
        <Route path="financial/audit" element={<FinancialAudit />} />
        <Route path="financial/bank-statements" element={<BankStatements />} />
        <Route path="financial/repasses" element={<Repasses />} />
        <Route path="financial/tef" element={<TefTransactions />} />
        <Route path="financial/nfse" element={<NFSe />} />
        <Route path="financial/nfse-companies" element={<NfseCompanies />} />
        <Route path="financial/receipts" element={<Receipts />} />
        <Route path="financial/checks-received" element={<ChecksReceived />} />
        <Route path="financial/checks-issued" element={<ChecksIssued />} />
        <Route path="financial/card-settlements" element={<CardSettlements />} />
        <Route path="financial/pending-discounts" element={<PendingDiscounts />} />
        <Route path="financial/professional-fees" element={<ProfessionalFees />} />
        <Route path="financial/dre" element={<Dre />} />
        <Route path="financial/dre/snapshots" element={<DreSnapshots />} />
        <Route path="financial/chart-of-accounts" element={<ChartOfAccounts />} />

        {/* Rotas do Estoque */}
        <Route path="inventory/items" element={<InventoryMain />} />
        <Route path="inventory/categories" element={<InventoryCategories />} />
        <Route path="inventory/locations" element={<InventoryLocations />} />
        <Route path="inventory/manufacturers" element={<InventoryManufacturers />} />
        <Route path="inventory/kits" element={<InventoryKits />} />
        <Route path="inventory/insurance-medications" element={<InsuranceMedications />} />
        <Route path="inventory/movements" element={<InventoryMovements />} />
        <Route path="inventory/requisitions" element={<InventoryRequisitions />} />
        
        <Route path="settings" element={<Settings />} />
        
        {/* Gestão de Usuários (admin) */}
        <Route path="user-management" element={<UserManagement />} />
        <Route path="platform-payments" element={<PlatformPlanPayments />} />

        {/* Administração - Unidades / Filiais (admin) */}
        <Route path="admin/units" element={<AdminUnits />} />
        
        {/* Rota para qualquer caminho não encontrado - redirecionar para agenda */}
        <Route path="*" element={<Navigate to="/agenda" replace />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes; 